import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../user/user.service";

@Injectable({ providedIn: "root" })
export class AuthGuard  {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userService.isAuthenticated()) {
      this.userService.loginSso("");
    } else {
      this.userService.loginSso(state.url);
    }
    return true;
  }
}
